import must from './must.json';
import might from './might.json';
import requests from './requests.json';
import phrasal3words from './phrasal3words.json';
import questiontags from './questiontags.json';
import zeroconditional from './zeroconditional.json';
import passive from './passive.json';
import firstconditional from './firstconditional.json';
import timeclause from './timeclause.json';
import secondConditional from './secondconditional.json';
import ifiwere from './ififwere.json';
import realvsimaginary from './realvsimaginary.json';
import definingvsnon from './defininvsnon.json';

export const GRAMMAR_M9 = [
...must,
...might,
...requests,
...phrasal3words,
...questiontags,
...zeroconditional,
...passive,
...firstconditional,
...timeclause,
...secondConditional,
...ifiwere,
...realvsimaginary,
...definingvsnon,
];